import React from 'react';

// Wrapper component
const Wrapper = ({ children, className = '' }) => {
  return (
    <div
      className={`bg-gray-100 max-w-xl min-h-screen mx-auto font-yekan flex flex-col ${className}`}
    >
      {children}
    </div>
  );
};

export default Wrapper;
